import React from 'react'
import { useNavigate } from 'react-router-dom'
import useSWR from 'swr'

import PersonalDetailsForm from '../../containers/users/PersonalDetailsForm'
import { useI18N } from '../../../libraries/i18n/hook'
import OnBoardingHeader from './Header'
import { getUserPreferences } from '../../../api/users'
import Loading from '../../components/layout/Loading'
import { CurrentUserContext } from '../../../libraries/auth'


const OnboardingPersonalPage = () => {
  const { t } = useI18N()
  const navigate = useNavigate()
  const { currentUser, removeLinkedinStorage } = React.useContext(CurrentUserContext)
  const { data, isLoading } = useSWR('/users/preferences', currentUser?.id ? getUserPreferences : null)
  const headerTitle = data?.onboardingCompleted ? t('onboarding.personal.title') : t('onboarding.title')
  const headerDescription = data?.onboardingCompleted ? t('onboarding.personal.update.description') : t('onboarding.description')

  const onSuccess = () => {
    removeLinkedinStorage()
    navigate('/onboarding/studies')
  }

  if(isLoading) {
    return <Loading />
  }

  return (
    <>
      <OnBoardingHeader title={headerTitle} description={headerDescription} />
      <PersonalDetailsForm onSuccess={onSuccess} />
    </>
  )
}

export default OnboardingPersonalPage
